export default "__VITE_ASSET__DwJBzkER__"